import React, { Component } from 'react';

class CounterInput extends Component {

	static defaultProps = {
		min: 0,
		max: 9,
	};

	constructor(props) {
		super(props);

		this.state = {
			value: props.input.value,
			focus: false,
		};
	}

	subtract = (e) => {
		e.preventDefault();

		if (this.props.input.value === this.props.min) return;

		this.props.input.onChange(--this.props.input.value);
	};

	add = (e) => {
		e.preventDefault();

		if (this.props.input.value === this.props.max) return;

		this.props.input.onChange(++this.props.input.value);
	};

	onFocus = (e) => {

	};

	onBlur = (e) => {

	};

	onChange = (e) => {
		this.props.input.onChange(e.target.value);
	};

	render() {
		const value = this.props.input.value;

		const attributes = {
			id: this.props.id,
			onFocus: this.onFocus,
			onBlur: this.onBlur,
			disabled: this.props.disabled || false,
			readOnly: true,
			value,
		};

		return (
			<div className={`
				large-input
				large-input--counter
				large-input--filled
				${this.state.focus ? 'large-input--focus' : ''}
				${this.props.className || ''}
				`}
			>
				<input {...attributes} />
				<label htmlFor={this.props.id}>{this.props.label}</label>
				<button
					className={`
						large-input__counter-button
						large-input__counter-button--minus
						${value === this.props.min ? 'large-input__counter-button--disabled' : ''}
					`}
					onClick={this.subtract}
				>–</button>
				<button
					className={`
						large-input__counter-button
						large-input__counter-button--plus
						${value === this.props.max ? 'large-input__counter-button--disabled' : ''}
					`}
					onClick={this.add}
				>+</button>
			</div>
		);

	}
}

export default CounterInput;



// WEBPACK FOOTER //
// ./src/components/CounterInput.jsx